module.exports = __webpack_public_path__ + "media/images/gh04-31d6cfe0d16ae931b73c59d7e0c089c0.png";